import { afterNextRender, ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoutingPath } from 'mbs-ui-shared@constants';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotFoundWrapperComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private auth = inject(AuthFacade);

  constructor() {
    afterNextRender(() => {
      let redirect = RoutingPath.ApNotFound;

      if (this.auth.isMBSMode) {
        if (['', '/'].includes(this.route.snapshot.url.toString().trim())) {
          redirect = RoutingPath.ApDashboard;
        }
      } else {
        redirect = RoutingPath.OnlineAccess;
      }

      this.router.navigate([redirect]);
    });
  }
}
